
import { Component, Prop, Vue } from 'vue-property-decorator';

import { Button } from '@warrenbrasil/nebraska-web';
import { InvestmentSuccess } from '@/modules/transaction/views/InvestmentTransaction/components/InvestmentSuccess';
import { TransactionDetails } from '@/modules/transaction/views/InvestmentTransaction/components/TransactionDetails';
import { moneyFormat } from '@/modules/common/helpers/currency';
import { trackTradeTransactionSuccessViewLoad } from './trackers';

@Component({
  components: {
    Button,
    InvestmentSuccess,
    TransactionDetails
  }
})
export default class TradeTransactionSuccess extends Vue {
  @Prop({ type: Number, required: true })
  private investedValue!: number;

  mounted() {
    trackTradeTransactionSuccessViewLoad();
  }

  private goBackToTrade() {
    this.$router.push({ name: 'trade' });
  }

  private get formattedValue() {
    return this.investedValue
      ? moneyFormat(this.investedValue)
      : 'Valor indefinido';
  }
}
